import ToolTip from './component'

export default ToolTip
